import React, { useContext } from "react";
import ThrottlingCheckbox from "integrations/components/ThrottlingCheckbox";
import AdditionalFields from "integrations/aws/common/AdditionalFields";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import { AdvancedOptionsContext } from "./context/AdvancedOptions";
const FormAdvancedOptions = ({ onChange }) => {
  const { formData } = useContext(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } = useContext(AdvancedOptionsContext);
  const { f5ThrottleEnabled, f5StoreFullMessage, disableTLSCheck } = formData;
  const handleToggle = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };
  return /* @__PURE__ */ React.createElement(AdditionalFields, { title: "Advanced Options", visible: isAdvancedOptionsVisible, onToggle: handleToggle }, /* @__PURE__ */ React.createElement(ThrottlingCheckbox, { id: "f5ThrottleEnabled", defaultChecked: f5ThrottleEnabled == null ? void 0 : f5ThrottleEnabled.value, onChange }), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "f5StoreFullMessage",
      type: "checkbox",
      value: "enable-storeFullMessage",
      defaultChecked: f5StoreFullMessage == null ? void 0 : f5StoreFullMessage.value,
      onChange,
      label: "Store Full Message",
      help: "Store the full original F5Networks log record message as full_message?"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "disableTLSCheck",
      type: "checkbox",
      value: "disable-TLSCheck",
      defaultChecked: disableTLSCheck == null ? void 0 : disableTLSCheck.value,
      onChange,
      label: "Disable TLS Validation",
      help: "Disable the TLS validation and trust all connection?"
    }
  ));
};
export default FormAdvancedOptions;
